"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationCodeInput = void 0;
var _react = require("react");
var _VerificationStyledComponents = require("./VerificationStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const VerificationCodeInput = props => {
  const {
    index,
    inputRef,
    handleInput,
    handleDelete,
    handlePaste,
    isError,
    isSubmitting,
    awaitingRes
  } = props;
  const verificationInputRef = (0, _react.useRef)(null);
  const onSetInputRef = instance => {
    verificationInputRef.current = instance;
    inputRef(instance, index);
  };
  const handleVerificationInput = e => {
    // eslint-disable-next-line no-param-reassign -- needs to reassign e.target
    e.target.value = e.target.value.replaceAll(/\D/g, '');
    if (e.target.value) {
      handleInput(index);
    }
  };
  const handleFocus = () => {
    if (verificationInputRef.current) {
      verificationInputRef.current.select();
    }
  };
  const handleKeyDown = event => {
    if (!verificationInputRef.current) {
      return;
    }
    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (verificationInputRef.current.value) {
        verificationInputRef.current.value = '';
      } else {
        event.preventDefault();
        handleDelete(index);
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationStyledComponents.StyledTextField, {
    type: "text",
    variant: "outlined",
    inputProps: {
      maxLength: 1,
      autoComplete: 'off',
      inputMode: 'numeric'
    },
    inputRef: onSetInputRef,
    error: isError,
    disabled: isSubmitting || awaitingRes,
    onInput: handleVerificationInput,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onPaste: handlePaste
  });
};
exports.VerificationCodeInput = VerificationCodeInput;
//# sourceMappingURL=VerificationCodeInput.js.map